<div class="container-fluid sell_dash" style="padding: 0%;">
	<div class="wrapper">
	   <div class="row">
		  <app-sidemenu></app-sidemenu>
		  <section class="right col-xl-10">
		   <app-sellheader></app-sellheader>
			<div class="kt-container  kt-container--fluid  kt-grid kt-grid--ver mt-2">
			  <div class="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor" id="kt_content">
				 <!-- begin:: Content -->
				 <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
					 <div class="col-md-12 col-12">
						 <div class="card-heading row justify-content-end">
							 <div class="col-md-4 col-1">
								 <img src="./assets/image/asset.png" width="25">
							 </div>
							 <div class="col-md-4 col-10">
								 <div class="title offset-lg-3">
									 <p>ALGORITHM</p>
								 </div>
							 </div>
							 <div class="col-md-4 end col-1">
								 
							 </div>
						 </div>
					 </div>
					 <div class="kt-portlet kt-portlet--tabs shadow-sm">
						 <div class="kt-portlet__head">
							 <div class="kt-portlet__head-toolbar">
								 <ul class="nav nav-tabs nav-tabs-space-xl nav-tabs-line nav-tabs-bold nav-tabs-line-3x nav-tabs-line-brand" role="tablist">
									 <li class="nav-item">
										 <a class="nav-link active essentials" data-toggle="tab" href="#kt_user_edit_tab_1" role="tab">
											 <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
												 <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
													 <polygon points="0 0 24 0 24 24 0 24" />
													 <path d="M12.9336061,16.072447 L19.36,10.9564761 L19.5181585,10.8312381 C20.1676248,10.3169571 20.2772143,9.3735535 19.7629333,8.72408713 C19.6917232,8.63415859 19.6104327,8.55269514 19.5206557,8.48129411 L12.9336854,3.24257445 C12.3871201,2.80788259 11.6128799,2.80788259 11.0663146,3.24257445 L4.47482784,8.48488609 C3.82645598,9.00054628 3.71887192,9.94418071 4.23453211,10.5925526 C4.30500305,10.6811601 4.38527899,10.7615046 4.47382636,10.8320511 L4.63,10.9564761 L11.0659024,16.0730648 C11.6126744,16.5077525 12.3871218,16.5074963 12.9336061,16.072447 Z" fill="#000000" fill-rule="nonzero" />
													 <path d="M11.0563554,18.6706981 L5.33593024,14.122919 C4.94553994,13.8125559 4.37746707,13.8774308 4.06710397,14.2678211 C4.06471678,14.2708238 4.06234874,14.2738418 4.06,14.2768747 L4.06,14.2768747 C3.75257288,14.6738539 3.82516916,15.244888 4.22214834,15.5523151 C4.22358765,15.5534297 4.2250303,15.55454 4.22647627,15.555646 L11.0872776,20.8031356 C11.6250734,21.2144692 12.371757,21.2145375 12.909628,20.8033023 L19.7677785,15.559828 C20.1693192,15.2528257 20.2459576,14.6784381 19.9389553,14.2768974 C19.9376429,14.2751809 19.9363245,14.2734691 19.935,14.2717619 L19.935,14.2717619 C19.6266937,13.8743807 19.0546209,13.8021712 18.6572397,14.1104775 C18.654352,14.112718 18.6514778,14.1149757 18.6486172,14.1172508 L12.9235044,18.6705218 C12.377022,19.1051477 11.6029199,19.1052208 11.0563554,18.6706981 Z" fill="#000000" opacity="0.3" />
												 </g>
											 </svg> Essentials
											 <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon ml-4">
											 <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
												 <polygon points="0 0 24 0 24 24 0 24"/>
												 <path d="M12.2928955,6.70710318 C11.9023712,6.31657888 11.9023712,5.68341391 12.2928955,5.29288961 C12.6834198,4.90236532 13.3165848,4.90236532 13.7071091,5.29288961 L19.7071091,11.2928896 C20.085688,11.6714686 20.0989336,12.281055 19.7371564,12.675721 L14.2371564,18.675721 C13.863964,19.08284 13.2313966,19.1103429 12.8242777,18.7371505 C12.4171587,18.3639581 12.3896557,17.7313908 12.7628481,17.3242718 L17.6158645,12.0300721 L12.2928955,6.70710318 Z" fill="#000000" fill-rule="nonzero"/>
												 <path d="M3.70710678,15.7071068 C3.31658249,16.0976311 2.68341751,16.0976311 2.29289322,15.7071068 C1.90236893,15.3165825 1.90236893,14.6834175 2.29289322,14.2928932 L8.29289322,8.29289322 C8.67147216,7.91431428 9.28105859,7.90106866 9.67572463,8.26284586 L15.6757246,13.7628459 C16.0828436,14.1360383 16.1103465,14.7686056 15.7371541,15.1757246 C15.3639617,15.5828436 14.7313944,15.6103465 14.3242754,15.2371541 L9.03007575,10.3841378 L3.70710678,15.7071068 Z" fill="#000000" fill-rule="nonzero" opacity="0.3" transform="translate(9.000003, 11.999999) rotate(-270.000000) translate(-9.000003, -11.999999) "/>
											 </g>
										  </svg>
										 </a>
									 </li>
									 <li class="nav-item">
										 <a class="nav-link stamping" data-toggle="tab" href="#kt_user_edit_tab_2" role="tab">
											 <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
														 <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
															 <rect x="0" y="0" width="24" height="24"></rect>
															 <path d="M2.56066017,10.6819805 L4.68198052,8.56066017 C5.26776695,7.97487373 6.21751442,7.97487373 6.80330086,8.56066017 L8.9246212,10.6819805 C9.51040764,11.267767 9.51040764,12.2175144 8.9246212,12.8033009 L6.80330086,14.9246212 C6.21751442,15.5104076 5.26776695,15.5104076 4.68198052,14.9246212 L2.56066017,12.8033009 C1.97487373,12.2175144 1.97487373,11.267767 2.56066017,10.6819805 Z M14.5606602,10.6819805 L16.6819805,8.56066017 C17.267767,7.97487373 18.2175144,7.97487373 18.8033009,8.56066017 L20.9246212,10.6819805 C21.5104076,11.267767 21.5104076,12.2175144 20.9246212,12.8033009 L18.8033009,14.9246212 C18.2175144,15.5104076 17.267767,15.5104076 16.6819805,14.9246212 L14.5606602,12.8033009 C13.9748737,12.2175144 13.9748737,11.267767 14.5606602,10.6819805 Z" fill="#000000" opacity="0.3"></path>
															 <path d="M8.56066017,16.6819805 L10.6819805,14.5606602 C11.267767,13.9748737 12.2175144,13.9748737 12.8033009,14.5606602 L14.9246212,16.6819805 C15.5104076,17.267767 15.5104076,18.2175144 14.9246212,18.8033009 L12.8033009,20.9246212 C12.2175144,21.5104076 11.267767,21.5104076 10.6819805,20.9246212 L8.56066017,18.8033009 C7.97487373,18.2175144 7.97487373,17.267767 8.56066017,16.6819805 Z M8.56066017,4.68198052 L10.6819805,2.56066017 C11.267767,1.97487373 12.2175144,1.97487373 12.8033009,2.56066017 L14.9246212,4.68198052 C15.5104076,5.26776695 15.5104076,6.21751442 14.9246212,6.80330086 L12.8033009,8.9246212 C12.2175144,9.51040764 11.267767,9.51040764 10.6819805,8.9246212 L8.56066017,6.80330086 C7.97487373,6.21751442 7.97487373,5.26776695 8.56066017,4.68198052 Z" fill="#000000"></path>
														 </g>
													 </svg> Stamping
													 <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon ml-4">
											 <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
												 <polygon points="0 0 24 0 24 24 0 24"/>
												 <path d="M12.2928955,6.70710318 C11.9023712,6.31657888 11.9023712,5.68341391 12.2928955,5.29288961 C12.6834198,4.90236532 13.3165848,4.90236532 13.7071091,5.29288961 L19.7071091,11.2928896 C20.085688,11.6714686 20.0989336,12.281055 19.7371564,12.675721 L14.2371564,18.675721 C13.863964,19.08284 13.2313966,19.1103429 12.8242777,18.7371505 C12.4171587,18.3639581 12.3896557,17.7313908 12.7628481,17.3242718 L17.6158645,12.0300721 L12.2928955,6.70710318 Z" fill="#000000" fill-rule="nonzero"/>
												 <path d="M3.70710678,15.7071068 C3.31658249,16.0976311 2.68341751,16.0976311 2.29289322,15.7071068 C1.90236893,15.3165825 1.90236893,14.6834175 2.29289322,14.2928932 L8.29289322,8.29289322 C8.67147216,7.91431428 9.28105859,7.90106866 9.67572463,8.26284586 L15.6757246,13.7628459 C16.0828436,14.1360383 16.1103465,14.7686056 15.7371541,15.1757246 C15.3639617,15.5828436 14.7313944,15.6103465 14.3242754,15.2371541 L9.03007575,10.3841378 L3.70710678,15.7071068 Z" fill="#000000" fill-rule="nonzero" opacity="0.3" transform="translate(9.000003, 11.999999) rotate(-270.000000) translate(-9.000003, -11.999999) "/>
											 </g>
										  </svg>
										 </a>
									 </li>
									 
									 <li class="nav-item">
										 <a class="nav-link storage" data-toggle="tab" href="#kt_user_edit_tab_3" role="tab">
											 <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
												 <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
													 <rect x="0" y="0" width="24" height="24" />
													 <path d="M4,4 L11.6314229,2.5691082 C11.8750185,2.52343403 12.1249815,2.52343403 12.3685771,2.5691082 L20,4 L20,13.2830094 C20,16.2173861 18.4883464,18.9447835 16,20.5 L12.5299989,22.6687507 C12.2057287,22.8714196 11.7942713,22.8714196 11.4700011,22.6687507 L8,20.5 C5.51165358,18.9447835 4,16.2173861 4,13.2830094 L4,4 Z" fill="#000000" opacity="0.3" />
													 <path d="M12,11 C10.8954305,11 10,10.1045695 10,9 C10,7.8954305 10.8954305,7 12,7 C13.1045695,7 14,7.8954305 14,9 C14,10.1045695 13.1045695,11 12,11 Z" fill="#000000" opacity="0.3" />
													 <path d="M7.00036205,16.4995035 C7.21569918,13.5165724 9.36772908,12 11.9907452,12 C14.6506758,12 16.8360465,13.4332455 16.9988413,16.5 C17.0053266,16.6221713 16.9988413,17 16.5815,17 C14.5228466,17 11.463736,17 7.4041679,17 C7.26484009,17 6.98863236,16.6619875 7.00036205,16.4995035 Z" fill="#000000" opacity="0.3" />
												 </g>
											 </svg> Storage	
											 <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon ml-4">
											 <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
												 <polygon points="0 0 24 0 24 24 0 24"/>
												 <path d="M12.2928955,6.70710318 C11.9023712,6.31657888 11.9023712,5.68341391 12.2928955,5.29288961 C12.6834198,4.90236532 13.3165848,4.90236532 13.7071091,5.29288961 L19.7071091,11.2928896 C20.085688,11.6714686 20.0989336,12.281055 19.7371564,12.675721 L14.2371564,18.675721 C13.863964,19.08284 13.2313966,19.1103429 12.8242777,18.7371505 C12.4171587,18.3639581 12.3896557,17.7313908 12.7628481,17.3242718 L17.6158645,12.0300721 L12.2928955,6.70710318 Z" fill="#000000" fill-rule="nonzero"/>
												 <path d="M3.70710678,15.7071068 C3.31658249,16.0976311 2.68341751,16.0976311 2.29289322,15.7071068 C1.90236893,15.3165825 1.90236893,14.6834175 2.29289322,14.2928932 L8.29289322,8.29289322 C8.67147216,7.91431428 9.28105859,7.90106866 9.67572463,8.26284586 L15.6757246,13.7628459 C16.0828436,14.1360383 16.1103465,14.7686056 15.7371541,15.1757246 C15.3639617,15.5828436 14.7313944,15.6103465 14.3242754,15.2371541 L9.03007575,10.3841378 L3.70710678,15.7071068 Z" fill="#000000" fill-rule="nonzero" opacity="0.3" transform="translate(9.000003, 11.999999) rotate(-270.000000) translate(-9.000003, -11.999999) "/>
											 </g>
										  </svg>
										 </a>
									 </li>
									 <li class="nav-item">
										 <a class="nav-link steward" data-toggle="tab" href="#kt_user_edit_tab_4" role="tab">
											 <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
												 <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
													 <polygon points="0 0 24 0 24 24 0 24" />
													 <path d="M12,11 C9.790861,11 8,9.209139 8,7 C8,4.790861 9.790861,3 12,3 C14.209139,3 16,4.790861 16,7 C16,9.209139 14.209139,11 12,11 Z" fill="#000000" fill-rule="nonzero" opacity="0.3" />
													 <path d="M3.00065168,20.1992055 C3.38825852,15.4265159 7.26191235,13 11.9833413,13 C16.7712164,13 20.7048837,15.2931929 20.9979143,20.2 C21.0095879,20.3954741 20.9979143,21 20.2466999,21 C16.541124,21 11.0347247,21 3.72750223,21 C3.47671215,21 2.97953825,20.45918 3.00065168,20.1992055 Z" fill="#000000" fill-rule="nonzero" />
												 </g>
											 </svg>Steward	
											 <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon ml-4">
											 <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
												 <polygon points="0 0 24 0 24 24 0 24"/>
												 <path d="M12.2928955,6.70710318 C11.9023712,6.31657888 11.9023712,5.68341391 12.2928955,5.29288961 C12.6834198,4.90236532 13.3165848,4.90236532 13.7071091,5.29288961 L19.7071091,11.2928896 C20.085688,11.6714686 20.0989336,12.281055 19.7371564,12.675721 L14.2371564,18.675721 C13.863964,19.08284 13.2313966,19.1103429 12.8242777,18.7371505 C12.4171587,18.3639581 12.3896557,17.7313908 12.7628481,17.3242718 L17.6158645,12.0300721 L12.2928955,6.70710318 Z" fill="#000000" fill-rule="nonzero"/>
												 <path d="M3.70710678,15.7071068 C3.31658249,16.0976311 2.68341751,16.0976311 2.29289322,15.7071068 C1.90236893,15.3165825 1.90236893,14.6834175 2.29289322,14.2928932 L8.29289322,8.29289322 C8.67147216,7.91431428 9.28105859,7.90106866 9.67572463,8.26284586 L15.6757246,13.7628459 C16.0828436,14.1360383 16.1103465,14.7686056 15.7371541,15.1757246 C15.3639617,15.5828436 14.7313944,15.6103465 14.3242754,15.2371541 L9.03007575,10.3841378 L3.70710678,15.7071068 Z" fill="#000000" fill-rule="nonzero" opacity="0.3" transform="translate(9.000003, 11.999999) rotate(-270.000000) translate(-9.000003, -11.999999) "/>
											 </g>
										  </svg>					
										 </a>
									 </li>
									 <li class="nav-item">
										 <a class="nav-link license" data-toggle="tab" href="#kt_user_edit_tab_5" role="tab">
											 <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
												 <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
													 <rect x="0" y="0" width="24" height="24" />
													 <path d="M6,2 L18,2 C18.5522847,2 19,2.44771525 19,3 L19,12 C19,12.5522847 18.5522847,13 18,13 L6,13 C5.44771525,13 5,12.5522847 5,12 L5,3 C5,2.44771525 5.44771525,2 6,2 Z M7.5,5 C7.22385763,5 7,5.22385763 7,5.5 C7,5.77614237 7.22385763,6 7.5,6 L13.5,6 C13.7761424,6 14,5.77614237 14,5.5 C14,5.22385763 13.7761424,5 13.5,5 L7.5,5 Z M7.5,7 C7.22385763,7 7,7.22385763 7,7.5 C7,7.77614237 7.22385763,8 7.5,8 L10.5,8 C10.7761424,8 11,7.77614237 11,7.5 C11,7.22385763 10.7761424,7 10.5,7 L7.5,7 Z" fill="#000000" opacity="0.3" />
													 <path d="M3.79274528,6.57253826 L12,12.5 L20.2072547,6.57253826 C20.4311176,6.4108595 20.7436609,6.46126971 20.9053396,6.68513259 C20.9668779,6.77033951 21,6.87277228 21,6.97787787 L21,17 C21,18.1045695 20.1045695,19 19,19 L5,19 C3.8954305,19 3,18.1045695 3,17 L3,6.97787787 C3,6.70173549 3.22385763,6.47787787 3.5,6.47787787 C3.60510559,6.47787787 3.70753836,6.51099993 3.79274528,6.57253826 Z" fill="#000000" />
												 </g>
											 </svg> License & Submit
										 </a>
									 </li>
								 </ul>
							 </div>
						 </div>
						 <div class="kt-portlet__body">
							 <div class="tab-content">
								 <div class="tab-pane active" id="kt_user_edit_tab_1" role="tabpanel">
									 <div class="kt-form kt-form--label-right">
										 <form (ngSubmit)="f.form.valid && onSubmit(f)" #f="ngForm">
											 <div class="kt-form__body">
												 <div class="kt-section kt-section--first">
													 <div class="kt-section__body">
													  <div class="row">
													   <div class="col-lg-10 col-xl-10">
														 <div class="form-group row">
														   <label class="col-xl-3 col-lg-3 col-form-label text-left pl-3">
														   	<img src="./assets/image/icons/algorithm/title.png" class="mr-2">Title*:</label>
														   <div class="col-lg-8 col-xl-8 ml-2 pl-5 mt-3">
															 <input class="form-control" type="text"
															   [ngModel]  name="title" #title="ngModel" placeholder="Nick" required
																[ngClass]="{'is-invalid': f.submitted && title.invalid }">
															 <div *ngIf="f.submitted && title.invalid" class="invalid-feedback">
															  <div *ngIf="title.errors.required">Title is required</div>
															   </div>
															 </div>
														 </div>
														 <div class="form-group row">
															 <label class="col-xl-3 col-lg-3 col-form-label text-left pl-3"><img src="./assets/image/icons/algorithm/category.png" class="mr-2">Category* :</label>
															 <div class="col-lg-8 col-xl-8 ml-2 pl-5">
																 <select class="form-control mt-3" [ngModel] #category name="category">
																	 <option value="Aeronautics & Defence">Aeronautics & Defence</option>
																	 <option value="Agriculture,Agrifood">Agriculture,Agrifood</option>
																	 <option value="Automotive"> Automotive</option><option value="Chemical Industry"> Chemical Industry</option>
																	 <option value="Consulting Management"> Consulting Management</option>
																	 <option value="Commerce, E-commerce"> Commerce, E-commerce</option>
																	 <option value="Education ,Training"> Education ,Training</option>
																	 <option value="Environment, Energy"> Environment, Energy</option>
																	 <option value="Marketing Branding">Marketing Branding</option>
																	 <option value="Engineering, Construction">Engineering, Construction</option>
																	 <option value="Healthcare"> Healthcare</option>
																	 <option value="Life Sources">Life Sources</option>
																	 <option value="Media,Publishing"> Media,Publishing</option>
																	 <option value="Non-Profit,Social">Non-Profit,Social</option>
																	 <option value="Public Sector">Public Sector</option>
																	 <option value="Real Estate"> Real Estate</option>
																	 <option value="Sports,Leisure">Sports,Leisure</option>
																	 <option value="Technology, IT"> Technology, IT</option><option value="Telecom"> Telecom</option>
																	 <option value="Transport,Logistic"> Transport,Logistic</option>
																	 <option value="Travel,Tourism"> Travel,Tourism</option>
																	 <option value="Utility Bills"> Utility Bills</option>
																	 <option value="Other"> Other</option>
																 </select>
															 </div>
														 </div>
													   </div>
													   <div class="col-lg-2 col-xl-2 mb-3">
														   <input type="file" name="file" hidden id="thumbnail" accept="image/*" (change)="imgFileSelected(file.files)" [ngModel] #file>
														   <img [src]="imgSrc" width="90" height="90" class="thumbnail-click" accept="image/*">
													   </div>
													  </div>
														 <div class="form-group row">
															 <label class="col-xl-3 col-lg-2 col-form-label text-left pl-3">
																 <img src="./assets/image/icons/algorithm/short_desc.png" class="mr-2">Short Description* :</label>
															 <div class="col-lg-8 col-xl-8 mt-3" id="mainshortdescription">
																 <textarea class="form-control shortdescription" rows="5" 
																 (keyup)="countChar(shortdescription)" [ngModel] #shortdescription="ngModel" name="shortdescription" required
																 [ngClass]="{'is-invalid': f.submitted && shortdescription.invalid }"></textarea>
																 <span id="charNum">{{shortdesclength}}/280</span>
																 <div *ngIf="f.submitted && shortdescription.invalid" class="invalid-feedback">
															  <div *ngIf="shortdescription.errors.required">Short Description is required</div>
															   </div>
															 </div>
														 </div>
 
														 <div class="form-group row">
															 <label class="col-xl-3 col-lg-3 col-form-label text-left pl-3"><img src="./assets/image/icons/algorithm/long_desc.png" class="mr-2">Long Description :</label>
															 <div class="col-lg-8 col-xl-8 mt-3">
																 <textarea class="form-control" rows="5" [ngModel] #longdescription name="longdescription"></textarea>
															 </div>
														 </div>
														 <div class="form-group row">
															 <label class="col-xl-3 col-lg-3 col-form-label text-left pl-3"><img src="./assets/image/icons/algorithm/smart_tag.png" class="mr-2">Smart Tags* :</label>
															 <div class="col-lg-8 col-xl-8 mt-3">
															 	<input name='keywords' value='[{"value":"Medical"}]' pattern='^[A-Za-z_✲ ]{1,15}$'>
															  </div>
													          <a  class="col-lg-1 col-xl-1 col-form-label mt-3 pt-1"><img src="./assets/image/info.png" 
																(mouseenter)="smart_tagInfo($event)"></a>
													 </div>
													 <div class="form-group kt-portlet__foot row">
														<div class="col-lg-3 col-xl-3 offset-lg-5 offset-xl-5">
															<button class="btn"><img src="../../../assets/image/savenext.png"></button> 
														</div>
													</div>
													 </div>
												 </div>
											 </div>
										</form>
									 </div>
								 </div>
								 <div class="tab-pane" id="kt_user_edit_tab_2" role="tabpanel">
									 <div class="kt-form kt-form--label-right">
										<form (ngSubmit)="f2.form.valid && onSubmit_tab2(f2)" #f2="ngForm">
										 <div class="kt-form__body">
											 <div class="kt-section kt-section--first">
												 <div class="kt-section__body">
													 <div class="form-group row">
														 <label class="col-xl-3 col-lg-3 col-form-label text-left pl-3"><img src="./assets/image/icons/algorithm/data_class.png" class="mr-2">Algo Classification:</label>
														 <div class="col-lg-8 col-xl-8 kt-radio-inline row mt-3 pt-1">
															 <div class="col-lg-2 col-xl-2">
																 <label class="kt-radio kt-radio--bold kt-radio--success">
																  <input type="radio" name="data_class" [ngModel] #data_class value="sensitive"> Sensitive
																   <span></span>
															      </label>
														       </div>
														 <div class="col-lg-3 col-xl-3">
															 <label class="kt-radio kt-radio--bold kt-radio--success">
																  <input type="radio" name="data_class" [ngModel]="'confidential'" #data_class value="confidential" checked="checked"> Confidential
																<span></span>
															 </label>
														 </div>
														 <div class="col-lg-2 col-xl-2">
															 <label class="kt-radio kt-radio--bold kt-radio--success">
																  <input type="radio" name="data_class" [ngModel] #data_class value="public"> Public
																<span></span>
															 </label>
														 </div>
															 </div>
															 <a  class="col-lg-1 col-xl-1 col-form-label ml-4 pl-4 mt-3 pt-1"><img src="./assets/image/info.png" (mouseenter)="data_classificationInfo($event)"></a>
														 </div>
														 <div class="form-group row">
														 <label class="col-xl-3 col-lg-3 col-form-label text-left pl-3"><img src="./assets/image/icons/algorithm/data_type.png" class="mr-2">Algo Type:</label>
														 <div class="col-lg-8 col-xl-8 kt-radio-inline row mt-3 pt-1">
															 <div class="col-lg-2 col-xl-2">
																 <label class="kt-radio kt-radio--bold kt-radio--success">
																  <input type="radio" name="data_type" id="data_raw" checked value="raw" [ngModel]="'raw'" #data_type> Raw
																<span></span>
															 </label>
														 </div>
														 <div class="col-lg-2 col-xl-2">
															 <label class="kt-radio kt-radio--bold kt-radio--success">
																  <input type="radio" name="data_type" id="data_transformed" value="transformed" [ngModel] #data_type> Transformed
																<span></span>
															 </label>
														 </div>
															 </div>
															 <a  class="col-lg-1 col-xl-1 col-form-label data_type ml-4 pl-4 mt-3 pt-1"><img src="./assets/image/info.png" 
																 (mouseenter)="data_typeInfo($event)"></a>
														 </div>
														 <div class="row form-group d-none dataset_id_verify pl-3
														 mt-3 pt-1">
															 <input type="text" name="dataset_id" class="form-control col-lg-6 col-xl-6 offset-lg-3" placeholder="List of Asset Id" [ngModel] #dataset_id>
														 </div>
														 <div class="row form-group d-none dataset_id_verify pl-3
														 mt-3 pt-1">
															 <span class="form-control col-lg-4 col-xl-4 offset-lg-3 verification_utility">Add Invoice & License File</span>
															 <button type="button" class="btn btn-label-brand btn-bold col-lg-2 col-xl-2 ml-1" (click)="onClick($event)">Upload</button>
														 </div>
														 <div class="form-group row mt-3 pt-1">
														 <label class="col-xl-3 col-lg-3 col-form-label text-left pl-3"><img src="./assets/image/icons/algorithm/data_territory.png" class="mr-2">Algo Territory:</label>
														 <div class="col-lg-8 col-xl-8 mt-3 pt-1">
													       <input name="territory">
												          </div>
												 <a  class="col-lg-1 col-xl-1 col-form-label mt-3 pt-1"><img src="./assets/image/info.png" 
													(mouseenter)="data_territoryInfo($event)"></a>
												 </div>
												 <div class="form-group row">
														 <label class="col-xl-3 col-lg-3 col-form-label text-left pl-3"><img src="./assets/image/icons/algorithm/data_period.png" class="mr-2">Collection Period:</label>
															 <div class="col-lg-4 col-xl-4 mt-3 pt-1">
																 <ejs-datepicker id='datepicker' placeholder='Start date' format ='dd-MM-yyyy' name="start_date"  [ngModel]  #start_date></ejs-datepicker>
															</div>
															<div class="col-lg-4 col-xl-4 mt-3 pt-1">
																 <ejs-datepicker id='datepicker'  placeholder='End date' format ='dd-MM-yyyy' name="end_date" [ngModel]  #end_date></ejs-datepicker>
															</div>
															<a  class="col-lg-1 col-xl-1 col-form-label mt-3 pt-1"><img src="./assets/image/info.png" 
																(mouseenter)="data_prodInfo($event)"></a>
												 </div>
												<div class="form-group row">
														<label class="col-xl-3 col-lg-3 col-form-label text-left pl-3"><img src="./assets/image/icons/algorithm/power.png" class="mr-2">Power Stamping:</label>
														<div class="col-lg-8 col-xl-8 mt-3 pt-1" id="pad">
															<label class="switch">
																<input type="checkbox">
																 <span class="slider round">
																 </span> 
															</label>
														</div>
														<a  class="col-lg-1 col-xl-1 col-form-label mt-3 pt-1"><img src="./assets/image/info.png" 
																(mouseenter)="powerInfo($event)"></a>
												</div>
												<div class="form-group row">
														   <label class="col-xl-3 col-lg-3 col-form-label text-left pl-3"><img src="./assets/image/icons/algorithm/link.png" class="mr-2">Visual or Demo: </label>
														   <div class="col-lg-8 col-xl-8 mt-3 pt-1">
															 <input class="form-control" type="text" placeholder="https://abc.com" [ngModel]  name="link" #link="ngModel">
														   </div>
														   <a  class="col-lg-1 col-xl-1 col-form-label mt-3 pt-1"><img src="./assets/image/info.png" 
																(mouseenter)="demoInfo($event)"></a>
												</div>
												<div class="form-group row">
														   <label class="col-xl-3 col-lg-3 col-form-label text-left pl-3"><img src="./assets/image/icons/algorithm/Quality.png" class="mr-2">Metrices or Specs:</label>
														   <div class="col-lg-8 col-xl-8 mt-3 pt-1">
															 <input class="form-control" type="text" placeholder="https://abc.com" [ngModel]  name="link" #link="ngModel">
														   </div>
														   <a  class="col-lg-1 col-xl-1 col-form-label mt-3 pt-1"><img src="./assets/image/info.png" 
																(mouseenter)="metricesInfo($event)"></a>
												 </div>
												 <div class="form-group row kt-portlet__foot">
													 <div class="col-lg-2 col-xl-2 offset-lg-4 offset-xl-4">
														 <button class="btn" (click)="p1($event)" type="button"><img src="../../../assets/image/previous.png"></button> 
													 </div>
													 <div class="col-lg-2 col-xl-2 text-center">
														<button class="btn" type="submit"><img src="../../../assets/image/savenext.png"></button> 
													 </div>
												 </div>
												 </div>
											 </div>
										 </div>
										</form>  
									 </div>
								 </div>
								 <div class="tab-pane" id="kt_user_edit_tab_3" role="tabpanel">
									 <div class="kt-form kt-form--label-right">
										<form (ngSubmit)="f4.form.valid && onSubmit_tab4(f4)" #f4="ngForm">
										 <div class="kt-form__body">
											 <div class="kt-section kt-section--first">
												 <div class="kt-section__body">
													 <div class="form-group row">
														 <label class="col-xl-3 col-lg-4 col-form-label text-left pl-3"><img src="./assets/image/icons/algorithm/data_flow.png" class="mr-2">Algo Flow:</label>
														 <div class="col-lg-7 col-xl-7 mt-2">
														  <div class="kt-radio-inline row">
														    <div class="col-lg-4 col-xl-4">
																 <label class="kt-radio kt-radio--bold kt-radio--success">
																   <input type="radio" [ngModel] #data_flow value="Flow via API" name="data_flow" class="data_flow_api"> Flow via API
																   <span></span>
															     </label>
														    </div>
															<div class="col-lg-2 col-xl-2">
																 <label class="kt-radio kt-radio--bold kt-radio--success">
																	  <input type="radio" name="data_flow" [ngModel]="'Files'" #data_flow value="Files" checked class="data_flow_files"> Files
																	<span></span>
																 </label>
															</div>
														    <div class="col-lg-2 col-xl-2">
															 <label class="kt-radio kt-radio--bold kt-radio--success">
																  <input type="radio" name="data_flow" [ngModel] #data_flow value="Both" class="data_flow_api"> Both
																<span></span>
															 </label>
														    </div>
														  </div>
														  <div class="row pl-3 mt-3 url_schema d-none">
														  	<div class="row col-lg-8">
														  		<input class="form-control" type="text" placeholder="API Signature Or url" [ngModel]  name="link" #link="ngModel">
														  	</div>
														  	<div class="row col-lg-8 mt-2">
														  		<input class="form-control" type="text" placeholder="Output Data Format" [ngModel]  name="link" #link="ngModel">
														  	</div>
														  	<div class="row col-lg-8 mt-2">
														  	   <span class="form-control col-lg-8 col-xl-8 data_dictionary_fill mr-1"></span>
														        <button type="button" class="btn btn-label-brand btn-bold col-lg-3 col-xl-3 form-control" (click)="onClick1($event)">Upload</button>
														  	</div>
														  </div>
														 </div>
															 <a class="col-lg-1 col-xl-1 col-form-label ml-5 pl-3
															 mt-3 pt-1"><img src="./assets/image/info.png" (mouseenter)="data_flowInfo($event)"></a>
														 </div>
													 <div class="form-group row">
														 <label class="col-xl-3 col-lg-4 col-form-label text-left pl-3"><img src="./assets/image/icons/algorithm/data_freq.png" class="mr-2">Algo Frequency:</label>
														 <div class="col-lg-8 col-xl-8 kt-radio-inline row mt-3 pt-1">
															 <div class="col-lg-3 col-xl-3">
																 <label class="kt-radio kt-radio--bold kt-radio--success">
																  <input type="radio" name="data_freq" id="one-time" checked value="One-time" [ngModel]="'One-time'" #data_freq> One-time
																<span></span>
															 </label>
														 </div>
														 <div class="col-lg-2 col-xl-2">
															 <label class="kt-radio kt-radio--bold kt-radio--success">
																  <input type="radio" name="data_freq" id="incremental" value="Incremental" [ngModel] #data_freq> Incremental
																<span></span>
															 </label>
														 </div>
															 </div>
															 <a class="col-lg-1 col-xl-1 col-form-label mt-3 pt-1"><img src="./assets/image/info.png" (mouseenter)="data_freqInfo($event)"></a>
														 </div>
														 <div class="form-group row d-none" id="incremental_type">
														   <div class="col-lg-7 col-xl-7 offset-lg-3">
															 <select class="form-control" [ngModel] #incremental_type name="incremental_type">
																<option value="Daily">Daily</option>
																<option value="Weekly">Weekly</option>
																<option value="Monthly">Monthly</option>
																<option value="Yearly">Yearly</option>
															 </select>
														   </div>
														 </div>
														 <div class="form-group row">
															<label class="col-xl-3 col-lg-3 col-form-label text-left pl-3"><img src="./assets/image/icons/algorithm/data_format.png" class="mr-2">Algo Format:</label>
														   <div class="col-lg-7 col-xl-7 mt-3">
															 <select class="form-control" [ngModel]="'ZIP'" #data_format name="data_format">
																 <option value="ZIP">ZIP</option>
															 </select>
														   </div>
														 </div>
														 <div class="form-group row">
														 <label class="col-xl-3 col-lg-3 col-form-label text-left pl-3"><img src="./assets/image/icons/algorithm/data_size.png" class="mr-2">Algo Size:</label>
														 <div class="col-lg-7 col-xl-7 kt-radio-inline row mt-3 pt-1">
															 <div class="col-lg-3 col-xl-3">
																 <label class="kt-radio kt-radio--bold kt-radio--success">
																  <input type="radio" name="data_size" checked [ngModel]="'0<=5GB'" #data_size value="0<=5GB"> 0<=5GB
																<span></span>
															 </label>
														 </div>
														 <div class="col-lg-3 col-xl-3">
															 <label class="kt-radio kt-radio--bold kt-radio--success">
																  <input type="radio" name="data_size" [ngModel] #data_size value="5GB-5TB"> 5GB-5TB
																<span></span>
															 </label>
														 </div>
														 <div class="col-lg-3 col-xl-1">
															 <label class="kt-radio kt-radio--bold kt-radio--success">
																  <input type="radio" name="data_size" [ngModel] #data_size value=">5TB"> >5TB
																<span></span>
															 </label>
														 </div>
															 </div>
															 <a class="col-lg-1 col-xl-1 col-form-label ml-5 pl-5 mt-3 pt-1"><img src="./assets/image/info.png" (mouseenter)="data_sizeInfo($event)"></a>
														 </div>
													 	 <div class="form-group row">
														 <label class="col-xl-3 col-lg-3 col-form-label text-left pl-3"><img src="./assets/image/icons/algorithm/dictionary.png" class="mr-2">Data Dictionary:</label>
														 <span class="form-control col-lg-5 col-xl-5 data_dictionary_fill ml-3 mt-3 pt-1"></span>
														 <button type="button" class="btn btn-label-brand btn-bold col-lg-2 col-xl-2 ml-1 form-control mt-3 pt-1" (click)="onClick1($event)">Upload</button>
														 <a class="col-lg-1 col-xl-1 col-form-label ml-4 pl-4 mt-3 pt-1"><img src="./assets/image/info.png" (mouseenter)="data_dictInfo($event)"></a>
														 </div>
 
														 <div class="form-group row">
														 <label class="col-xl-3 col-lg-3 col-form-label text-left pl-3"><img src="./assets/image/icons/algorithm/preview.png" class="mr-2">Preview File:</label>
														 <span class="form-control col-lg-5 col-xl-5 preview_file_fill ml-3 mt-3 pt-1"></span>
														 <button type="button" class="btn btn-label-brand btn-bold col-lg-2 col-xl-2 ml-1 form-control mt-3 pt-1" (click)="onClick2($event)">Upload</button>
														 <a class="col-lg-1 col-xl-1 col-form-label ml-4 pl-4 mt-3 pt-1"><img src="./assets/image/info.png" (mouseenter)="data_previewInfo($event)"></a>
														 </div>
 
														 <div class="form-group row">
														 <label class="col-xl-3 col-lg-4 col-form-label text-left pl-3"><img src="./assets/image/icons/algorithm/dataset.png" class="mr-2">Dataset:</label>
														 <span class="form-control col-lg-5 col-xl-5 add_dataset_fill ml-3 mt-3 pt-1"></span>
														 <button type="button" class="btn btn-label-brand btn-bold col-lg-2 col-xl-2 ml-1 form-control mt-3 pt-1" (click)="onClick3($event)">Upload</button>
														 <a  class="col-lg-1 col-xl-1 col-form-label ml-4 pl-4 mt-3 pt-1"><img src="./assets/image/info.png" (mouseenter)="data_datasetInfo($event)"></a>
														 </div>

														 <div class="form-group row">
														 <label class="col-xl-3 col-lg-4 col-form-label text-left pl-3"><img src="./assets/image/icons/algorithm/metadata.png" class="mr-2">Metadata:</label>
														 <span class="form-control col-lg-5 col-xl-5 add_metadata_fill ml-3 mt-3 pt-1"></span>
														 <button type="button" class="btn btn-label-brand btn-bold col-lg-2 col-xl-2 ml-1 form-control mt-3 pt-1" (click)="onClick4($event)">Upload</button>
														 <a class="col-lg-1 col-xl-1 col-form-label ml-4 pl-4 mt-3 pt-1"><img src="./assets/image/info.png" (mouseenter)="data_metadataInfo($event)"></a>
														 </div>
														 <div class="form-group row kt-portlet__foot">
															<div class="col-lg-2 col-xl-2 offset-lg-4 offset-lg-4">
																<button class="btn" (click)="p3($event)" type="button"><img src="../../../assets/image/previous.png"></button> 
															</div>
															<div class="col-lg-2 col-xl-2 text-center">
															   <button class="btn"><img src="../../../assets/image/savenext.png"></button> 
															</div>
														</div>
 
														 
												 </div>
											 </div>
										 </div>
										 </form>
									 </div>
								 </div>
								 <div class="tab-pane" id="kt_user_edit_tab_4" role="tabpanel">
									 <div class="kt-form kt-form--label-right">
										<form (ngSubmit)="f3.form.valid && onSubmit_tab3(f3)" #f3="ngForm">
										 <div class="kt-form__body">
											 <div class="kt-section kt-section--first">
												 <div class="kt-section__body">
													 <div class="row">
														 <label class="col-xl-3"></label>
														 <div class="col-lg-9 col-xl-6">
															 <h3 class="kt-section__title kt-section__title-sm">Primary Steward:</h3>
														 </div>
													 </div>
													 <div class="form-group row">
														 <label class="col-xl-3 col-lg-3 col-form-label text-left pl-3"><img src="./assets/image/icons/algorithm/name.png" class="mr-2">Name :</label>
														  <div class="col-lg-8 col-xl-8 mt-3 pt-1">
														   	<div class="input-group">
														   		<div class="input-group-prepend">
														   			<span class="input-group-text">
														   				<i class="la la-user"></i>
														   			</span>
														   		</div>
														   	  <input class="form-control" [ngModel]  name="name" #name="ngModel" placeholder="Nick" required [ngClass]="{'is-invalid': f3.submitted && name.invalid }" type="text">
														   	   <div *ngIf="f3.submitted && name.invalid"   class="invalid-feedback">
																  <div *ngIf="name.errors.required">Name is required</div>
															   </div>
														    </div>
															</div>
														 </div>
														 <div class="form-group row">
														 <label class="col-xl-3 col-lg-3 col-form-label text-left pl-3"><img src="./assets/image/icons/algorithm/email.png" class="mr-2">Email:</label>
														   <div class="col-lg-8 col-xl-8 mt-3 pt-1">
															 <div class="input-group">
														   		<div class="input-group-prepend">
														   			<span class="input-group-text">
														   				<i class="la la-at"></i>
														   			</span>
														   		</div>
														   	  <input class="form-control" [ngModel]  name="email" #email="ngModel" required
															   [ngClass]="{'is-invalid': f3.submitted && email.invalid }" type="email" placeholder="ab@gmail.com">
															   <div *ngIf="f3.submitted && email.invalid" class="invalid-feedback">
																  <div *ngIf="email.errors.required">Email is required</div>
																</div>
														    </div>
															</div>
														 </div>
														  <div class="form-group row">
														 <label class="col-xl-3 col-lg-3 col-form-label text-left pl-3"><img src="./assets/image/icons/algorithm/phone.png" class="mr-2">Phone:</label>
														   <div class="col-lg-8 col-xl-8 mt-3 pt-1">
														   	 <div class="input-group">
														   		<div class="input-group-prepend">
														   			<span class="input-group-text">
														   				<i class="la la-phone"></i>
														   			</span>
														   		</div>
														   	  <input class="form-control" [ngModel]  name="phone" #phone="ngModel" required
															  [ngClass]="{'is-invalid': f3.submitted && phone.invalid }" type="text" placeholder="0123456789">
															   <div *ngIf="f3.submitted && phone.invalid" class="invalid-feedback">
																  <div *ngIf="phone.errors.required">Phone Number is required</div>
															   </div>
														    </div>
															</div>
														 </div>
														 <div class="row">
														 <label class="col-xl-3"></label>
														 <div class="col-lg-9 col-xl-6">
															 <h3 class="kt-section__title kt-section__title-sm">Secondary Steward:</h3>
														 </div>
													 </div>
													 <div class="form-group row">
														 <label class="col-xl-3 col-lg-3 col-form-label text-left pl-3"><img src="./assets/image/icons/algorithm/name.png" class="mr-2">Name :</label>
														   <div class="col-lg-8 col-xl-8 mt-3 pt-1">
														   	<div class="input-group">
														   		<div class="input-group-prepend">
														   			<span class="input-group-text">
														   				<i class="la la-user"></i>
														   			</span>
														   		</div>
														   	 <input class="form-control" type="text" placeholder="Nick"  [ngModel]  name="sec_name" #sec_name="ngModel">
														    </div>
															</div>
														 </div>
														 <div class="form-group row">
														 <label class="col-xl-3 col-lg-3 col-form-label text-left pl-3"><img src="./assets/image/icons/algorithm/email.png" class="mr-2">Email:</label>
														   <div class="col-lg-8 col-xl-8 mt-3 pt-1">
														   	<div class="input-group">
														   		<div class="input-group-prepend">
														   			<span class="input-group-text">
														   				<i class="la la-at"></i>
														   			</span>
														   		</div>
														   	  <input class="form-control" type="email" placeholder="ab@gmail.com" [ngModel]  name="sec_email" #sec_email="ngModel">
														     </div>
															</div>
														 </div>
														  <div class="form-group row">
														 <label class="col-xl-3 col-lg-3 col-form-label text-left pl-3"><img src="./assets/image/icons/algorithm/phone.png" class="mr-2">Phone:</label>
														   <div class="col-lg-8 col-xl-8 mt-3 pt-1">
														   	<div class="input-group">
														   		<div class="input-group-prepend">
														   			<span class="input-group-text">
														   				<i class="la la-phone"></i>
														   			</span>
														   		</div>
														   	   <input class="form-control" type="text"placeholder="0123456789" [ngModel]  name="sec_phone" #sec_phone="ngModel">
														     </div>
															</div>
														 </div>
														 <div class="form-group kt-portlet__foot  row">
															<div class="col-lg-2 col-xl-2 offset-lg-4 offset-xl-4">
																<button class="btn" (click)="p2($event)" type="button"><img src="../../../assets/image/previous.png"></button> 
															</div>
															<div class="col-lg-2 col-xl-2 text-center">
															   <button class="btn"><img src="../../../assets/image/savenext.png"></button> 
															</div>
														</div>
												 </div>
											 </div>
										 </div>
										</form>
									 </div>
								 </div>
								 <div class="tab-pane" id="kt_user_edit_tab_5" role="tabpanel">
									 <div class="kt-form kt-form--label-right">
										<form (ngSubmit)="f5.form.valid && onSubmit_tab5(f5)" #f5="ngForm">
										 <div class="kt-form__body">
											 <div class="kt-section kt-section--first">
												 <div class="kt-section__body">
													 <div class="form-group row">
														 <label class="col-xl-3 col-lg-3 col-form-label text-left pl-3"><img src="./assets/image/icons/algorithm/objective.png" class="mr-2">Objective:</label>
														 <div class="col-lg-8 col-xl-8 mt-3 pt-1">
															 <angular2-multiselect [data]="dropdownList" [(ngModel)]="selectedItems"  [settings]="dropdownSettings" name="Objective" #Objective>	
															 </angular2-multiselect>
														 </div>
														   <a class="col-lg-1 col-xl-1 col-form-label mt-3 pt-1"><img src="./assets/image/info.png" (mouseenter)="data_objectiveInfo($event)"></a>
														 </div>
														 <div class="form-group row">
														 <label class="col-xl-3 col-lg-3 col-form-label text-left pl-3"><img src="./assets/image/icons/algorithm/sourcing.png" class="mr-2">Sourcing:</label>
														 <div class="col-lg-8 col-xl-8 mt-3 pt-1">
															 <angular2-multiselect [data]="sourceList" [(ngModel)]="selectedsource"  [settings]="sourceSettings" name="Sourcing" #Sourcing>
															 </angular2-multiselect>
														 </div>
															<a class="col-lg-1 col-xl-1 col-form-label mt-3 pt-1"><img src="./assets/image/info.png" (mouseenter)="data_sourcingInfo($event)"></a>
														 </div>
														 <div class="row form-group text-left pl-3">
															 <label class="col-lg-3 col-xl-3"></label>
															 <textarea rows="4" name="description" placeholder="Description" [ngModel] #description='ngModel' class="col-lg-8 col-xl-8 mt-3 pt-1"></textarea>
														 </div>
														 <div class="form-group row">
														    <label class="col-xl-3 col-lg-3 col-form-label text-left pl-3"><img src="./assets/image/icons/algorithm/license.png" class="mr-2">License Type:</label>
														    <div class="col-lg-2 col-xl-2 mt-3 pt-1">
															    <div class="row ml-1">
															      <label class="kt-checkbox kt-checkbox--success" >
																	 <input type="checkbox" name='check' [ngModel] #check required class="regular_ltype">Regular
																	 <span></span>
																  </label>
																</div>
																<div class="row  regular_ltype_cost d-none">
															     <div class="col-lg-8 col-xl-8">
																	 <select class="form-control" name="currency" [ngModel]="'USD'" #currency>
																		 <option value="USD">USD</option>
																		 <option value="INR">INR</option>
																	 </select> 
																 </div>
															    <input type="text" name="estimated_price" class="form-control col-lg-4 col-xl-4" [ngModel] #estimated_price='ngModel'>
															   </div>
															   
														  </div>
														   <div class="col-lg-2 col-xl-2 mt-3 pt-1">
															    <div class="row ml-1">
															      <label class="kt-checkbox kt-checkbox--success" >
																	 <input type="checkbox" name='check' [ngModel] #check required class="extended_ltype">Extended
																	 <span></span>
																  </label>
																</div>
																<div class="row extended_ltype_cost d-none">
															     <div class="col-lg-8 col-xl-8">
																	 <select class="form-control" name="currency" [ngModel]="'USD'" #currency>
																		 <option value="USD">USD</option>
																		 <option value="INR">INR</option>
																	 </select> 
																 </div>
															    <input type="text" name="estimated_price" class="form-control col-lg-4 col-xl-4" [ngModel] #estimated_price='ngModel'>
															   </div>
														  </div>
														   <div class="col-lg-3 col-xl-3 mt-3 pt-1">
															    <div class="row ml-1">
															      <label class="kt-checkbox kt-checkbox--success" >
																	 <input type="checkbox" name='check' [ngModel] #check required class="sextended_ltype">Super Extended
																	 <span></span>
																  </label>
																</div>
																<div class="row sextended_ltype_cost d-none">
															     <div class="col-lg-7 col-xl-7">
																	 <select class="form-control" name="currency" [ngModel]="'USD'" #currency>
																		 <option value="USD">USD</option>
																		 <option value="INR">INR</option>
																	 </select> 
																 </div>
															    <input type="text" name="estimated_price" class="form-control col-lg-5 col-xl-5" [ngModel] #estimated_price='ngModel'>
															   </div>
														  </div>
														  <a class="col-lg-1 col-xl-1 col-form-label ml-5 pl-5 mt-3 pt-1"><img src="./assets/image/info.png" (mouseenter)="data_licensetypeInfo($event)"></a>
														 </div>
													   <div class="form-group row">
														 <label class="col-xl-3 col-lg-3 col-form-label text-left pl-3"><img src="./assets/image/icons/algorithm/warranty.png" class="mr-2">Warranty:</label>
														 <div class="col-lg-8 col-xl-8 mt-2 pt-1">
														 	<div class="kt-radio-inline row">
															  <div class="col-lg-6 col-xl-6">
																 <label class="kt-radio kt-radio--bold kt-radio--success">
																  <input type="radio" name="data_freq" id="one_month_type" checked value="One-time" [ngModel]="'One-time'" #data_freq> One Month Free
																    <span></span>
															     </label>
														      </div>
															   <div class="col-lg-6 col-xl-6">
																	 <label class="kt-radio kt-radio--bold kt-radio--success">
																		  <input type="radio" name="data_freq" id="extended_type" value="Incremental" [ngModel] #data_freq> Extended
																		<span></span>
																	 </label>
															   </div>
															</div>
															<div class="row mt-2 pl-3 d-none warranty_type">
																 <div class="row">
																  	  <div class="col-lg-4 col-xl-4">
																        <label class="kt-checkbox kt-checkbox--success" >
																		 <input type="checkbox" name='check' [ngModel] #check required>3 Months
																		 <span></span>
																	    </label>
																     </div>
																     <div class="col-lg-4 col-xl-4">
																		 <select class="form-control" name="currency" [ngModel]="'USD'" #currency>
																			 <option value="USD">USD</option>
																			 <option value="INR">INR</option>
																		 </select> 
																	 </div>
															         <input type="text" name="estimated_price" class="form-control col-lg-4 col-xl-4" [ngModel] #estimated_price='ngModel'>
															     </div>
															   <div class="row mt-2">
																  	  <div class="col-lg-4 col-xl-4">
																        <label class="kt-checkbox kt-checkbox--success" >
																		 <input type="checkbox" name='check' [ngModel] #check required>6 Months
																		 <span></span>
																	    </label>
																     </div>
																     <div class="col-lg-4 col-xl-4">
																		 <select class="form-control" name="currency" [ngModel]="'USD'" #currency>
																			 <option value="USD">USD</option>
																			 <option value="INR">INR</option>
																		 </select> 
																	 </div>
															         <input type="text" name="estimated_price" class="form-control col-lg-4 col-xl-4" [ngModel] #estimated_price='ngModel'>
															     </div>
															  <div class="row mt-2">
																  	  <div class="col-lg-4 col-xl-4">
																        <label class="kt-checkbox kt-checkbox--success" >
																		 <input type="checkbox" name='check' [ngModel] #check required>12 Months
																		 <span></span>
																	    </label>
																     </div>
																     <div class="col-lg-4 col-xl-4">
																		 <select class="form-control" name="currency" [ngModel]="'USD'" #currency>
																			 <option value="USD">USD</option>
																			 <option value="INR">INR</option>
																		 </select> 
																	 </div>
															         <input type="text" name="estimated_price" class="form-control col-lg-4 col-xl-4" [ngModel] #estimated_price='ngModel'>
															     </div>
														 </div>
														</div>
														<a class="col-lg-1 col-xl-1 col-form-label mt-3 pt-1"><img src="./assets/image/info.png" (mouseenter)="data_warrantyInfo($event)"></a>
													</div>
														 <div class="form-group row">
														 <label class="col-xl-3 col-lg-4 col-form-label"></label>
														 <div class="col-lg-7 col-xl-8 mt-2">
															<label class="kt-checkbox kt-checkbox--success" >
																 <input type="checkbox" name='check' [ngModel] #check required>I am the certified owner of this asset.
																 <span></span>
															 </label>
															 <div *ngIf="f5.submitted && check.invalid" class="invalid-feedback">
																<div *ngIf="check.errors.required">Checkbox cannot be empty.</div>
																 </div>
															 </div>
															 <a class="col-lg-1 col-xl-1 col-form-label "><img src="./assets/image/info.png" (mouseenter)="data_certiInfo($event)"></a>
														 </div>

														 <div class="form-group kt-portlet__foot row">
															<div class="col-lg-2 col-xl-2 offset-xl-4 offset-lg-4">
																<button class="btn" (click)="p4($event)" type="button"><img src="../../../assets/image/previous.png"></button> 
															</div>
															<div class="col-lg-2 col-xl-2 text-center">
															   <button class="btn"><img src="../../../assets/image/submit.png"></button> 
															</div>
														</div>
												 </div>
											 </div>
										 </div>
										 </form>
									 </div>
								 </div>
							 </div>
							 
						 </div>
					 </div>
				 </div>
				 <!-- end:: Content -->
			  </div>
			 </div>
			 <app-algoinfomodal></app-algoinfomodal>       
		  </section>
			  <!-- begin::Sticky Toolbar -->
		  <app-stickytoolbar></app-stickytoolbar>
			   <!-- end::Sticky Toolbar -->
   </div>
  </div>
 </div>
 
 
 <!-- Data type modal -->
 
 <div class="modal fade uploadmodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
   <div class="modal-dialog modal-dialog-centered" role="document">
	 <div class="modal-content">
		 <div class="close_icon">
			 <a data-target="uploadmodal" data-dismiss="modal"><img src="./assets/image/icons/close.png"></a>
		 </div>
	   <div class="modal-body">
		   <div class="row mt-1">
			   <div class="col-lg-11 text-center">
				   <p class="pl-5">
					   <span class="underline">Add Path</span>
				   </p>
			   </div>
		   </div>
		   <div class="row justify-content-center mr-1 mt-4 mb-2">
			   <div class="col-lg-5">
				   <a (click)="path($event)"><img src="./assets/image/upload_drive.png" width="190"></a>
			</div>
			<div class="col-lg-1 pt-5">
				<p class="uploadOption">OR</p>
			</div>
			<div class="col-lg-5">
				   <img src="./assets/image/upload_folder.png" width="190" id="localpath1">
			   <input type="file" name="upload" class="form control" id="inputlocalpath1" hidden>
			</div>
		</div>
	   </div>
	 </div>
   </div>
 </div>
 
 <div class="modal fade uploadpath" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
   <div class="modal-dialog modal-dialog-centered" role="document">
	 <div class="modal-content">
		 <div class="close_icon">
			 <a data-target="uploadpath" data-dismiss="modal"><img src="./assets/image/icons/close.png"></a>
		 </div>
	   <div class="modal-body">
		   <div class="row mt-1 mb-3">
			   <div class="col-lg-11 text-center">
				   <p class="pl-5">
					   <span class="underline">Add Path</span>
				   </p>
			   </div>
		   </div>
		   <div class="row mt-2">
			   <div class="card-body uploadCard mx-3">
			 <form (ngSubmit)="f_s3.form.valid && onSubmit_dts3path(f_s3)" #f_s3="ngForm">
			  <div class="col-lg-12 text-center pathText">
				  <p>Add path from cloud storage</p>
			  </div>
			  <div class="col-lg-12 form-group">
				  <input type="text" [ngModel]  name="s3_path" class="form-control pathLink" placeholder="Add s3://path" 
				#s3_path="ngModel" required [ngClass]="{'is-invalid': f_s3.submitted && s3_path.invalid }">
			   <div *ngIf="f_s3.submitted && s3_path.invalid" class="invalid-feedback">
				  <div *ngIf="s3_path.errors.required">s3 path is required</div>
				</div>
			  </div>
			  <div class="col-lg-12 text-center mt-3 form-group">
				  <button type="submit" class="btn btn-primary px-3 pathButton">Add</button>
			  </div>
			</form>
			</div>
		</div>
	   </div>
	 </div>
   </div>
 </div>
 
 <!-- end of data type modal -->
 
 
 <!-- Data Dictionary modal -->
 
 <div class="modal fade uploadmodal1" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered" role="document">
	  <div class="modal-content">
		  <div class="close_icon">
			  <a data-target="uploadmodal1" data-dismiss="modal"><img src="./assets/image/icons/close.png"></a>
		  </div>
		<div class="modal-body">
			<div class="row mt-1">
				<div class="col-lg-11 text-center">
					<p class="pl-5">
						<span class="underline">Add Path</span>
					</p>
				</div>
			</div>
			<div class="row justify-content-center mr-1 mt-4 mb-2">
				<div class="col-lg-5">
					<a (click)="path1($event)"><img src="./assets/image/upload_drive.png" width="190"></a>
			 </div>
			 <div class="col-lg-1 pt-5">
				 <p class="uploadOption">OR</p>
			 </div>
			 <div class="col-lg-5">
					<img src="./assets/image/upload_folder.png" width="190" id="localpath2">
				<input type="file" name="upload" class="form control" id="inputlocalpath2" hidden>
			 </div>
		 </div>
		</div>
	  </div>
	</div>
  </div>
  
  <div class="modal fade uploadpath1" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered" role="document">
	  <div class="modal-content">
		  <div class="close_icon">
			  <a data-target="uploadpath1" data-dismiss="modal"><img src="./assets/image/icons/close.png"></a>
		  </div>
		<div class="modal-body">
			<div class="row mt-1 mb-3">
				<div class="col-lg-11 text-center">
					<p class="pl-5">
						<span class="underline">Add Path</span>
					</p>
				</div>
			</div>
			<div class="row mt-2">
				<div class="card-body uploadCard mx-3">
			  <form (ngSubmit)="f_s4.form.valid && onSubmit_dts4path(f_s4)" #f_s4="ngForm">
			   <div class="col-lg-12 text-center pathText">
				   <p>Add path from cloud storage</p>
			   </div>
			   <div class="col-lg-12 form-group">
				   <input type="text" [ngModel]  name="s4_path" class="form-control pathLink" placeholder="Add s3://path" 
				 #s4_path="ngModel" required [ngClass]="{'is-invalid': f_s4.submitted && s4_path.invalid }">
				<div *ngIf="f_s4.submitted && s4_path.invalid" class="invalid-feedback">
				   <div *ngIf="s4_path.errors.required">s3 path is required</div>
				 </div>
			   </div>
			   <div class="col-lg-12 text-center mt-3 form-group">
				   <button type="submit" class="btn btn-primary px-3 pathButton">Add</button>
			   </div>
			 </form>
			 </div>
		 </div>
		</div>
	  </div>
	</div>
  </div>
  
  <!-- end of data dictionary modal -->

  <!-- Preview File modal -->
 
 <div class="modal fade uploadmodal2" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered" role="document">
	  <div class="modal-content">
		  <div class="close_icon">
			  <a data-target="uploadmodal2" data-dismiss="modal"><img src="./assets/image/icons/close.png"></a>
		  </div>
		<div class="modal-body">
			<div class="row mt-1">
				<div class="col-lg-11 text-center">
					<p class="pl-5">
						<span class="underline">Add Path</span>
					</p>
				</div>
			</div>
			<div class="row justify-content-center mr-1 mt-4 mb-2">
				<div class="col-lg-5">
					<a (click)="path2($event)"><img src="./assets/image/upload_drive.png" width="190"></a>
			 </div>
			 <div class="col-lg-1 pt-5">
				 <p class="uploadOption">OR</p>
			 </div>
			 <div class="col-lg-5">
					<img src="./assets/image/upload_folder.png" width="190" id="localpath3">
				<input type="file" name="upload" class="form control" id="inputlocalpath3" hidden>
			 </div>
		 </div>
		</div>
	  </div>
	</div>
  </div>
  
  <div class="modal fade uploadpath2" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered" role="document">
	  <div class="modal-content">
		  <div class="close_icon">
			  <a data-target="uploadpath2" data-dismiss="modal"><img src="./assets/image/icons/close.png"></a>
		  </div>
		<div class="modal-body">
			<div class="row mt-1 mb-3">
				<div class="col-lg-11 text-center">
					<p class="pl-5">
						<span class="underline">Add Path</span>
					</p>
				</div>
			</div>
			<div class="row mt-2">
				<div class="card-body uploadCard mx-3">
			  <form (ngSubmit)="f_s5.form.valid && onSubmit_dts5path(f_s5)" #f_s5="ngForm">
			   <div class="col-lg-12 text-center pathText">
				   <p>Add path from cloud storage</p>
			   </div>
			   <div class="col-lg-12 form-group">
				   <input type="text" [ngModel]  name="s5_path" class="form-control pathLink" placeholder="Add s3://path" 
				 #s5_path="ngModel" required [ngClass]="{'is-invalid': f_s5.submitted && s5_path.invalid }">
				<div *ngIf="f_s5.submitted && s5_path.invalid" class="invalid-feedback">
				   <div *ngIf="s5_path.errors.required">s3 path is required</div>
				 </div>
			   </div>
			   <div class="col-lg-12 text-center mt-3 form-group">
				   <button type="submit" class="btn btn-primary px-3 pathButton">Add</button>
			   </div>
			 </form>
			 </div>
		 </div>
		</div>
	  </div>
	</div>
  </div>
  
  <!--End of Preview File modal -->

  <!-- Add Dataset modal -->
 
 <div class="modal fade uploadmodal3" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered modal-lg" role="document">
	  <div class="modal-content">
		  <div class="close_icon">
			  <a data-target="uploadmodal3" data-dismiss="modal"><img src="./assets/image/icons/close.png"></a>
		  </div>
		<div class="modal-body">
			<div class="row mt-1">
				<div class="col-lg-11 text-center">
					<p class="pl-5">
						<span class="underline">Add Path</span>
					</p>
				</div>
			</div>
			<div class="row justify-content-center mr-1 mt-4 mb-2">
				<div class="col-lg-3">
					<a (click)="path3($event)"><img src="./assets/image/upload_drive.png" width="190"></a>
			 </div>
			 <div class="col-lg-1 pt-5 ml-3">
				 <p class="uploadOption">OR</p>
			 </div>
			 <div class="col-lg-3">
					<img src="./assets/image/self_managed.png" width="190">
				<input type="file" name="upload" class="form control" hidden>
			 </div>
			 <div class="col-lg-1 pt-5">
				 <p class="uploadOption">OR</p>
			 </div>
			 <div class="col-lg-3">
					<img src="./assets/image/upload_folder.png" width="190" id="localpath4">
				<input type="file" name="upload" class="form control" id="inputlocalpath4" hidden>
			 </div>
		 </div>
		</div>
	  </div>
	</div>
  </div>
  
  <div class="modal fade uploadpath3" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered" role="document">
	  <div class="modal-content">
		  <div class="close_icon">
			  <a data-target="uploadpath3" data-dismiss="modal"><img src="./assets/image/icons/close.png"></a>
		  </div>
		<div class="modal-body">
			<div class="row mt-1 mb-3">
				<div class="col-lg-11 text-center">
					<p class="pl-5">
						<span class="underline">Add Path</span>
					</p>
				</div>
			</div>
			<div class="row mt-2">
				<div class="card-body uploadCard mx-3">
			  <form (ngSubmit)="f_s6.form.valid && onSubmit_dts6path(f_s6)" #f_s6="ngForm">
			   <div class="col-lg-12 text-center pathText">
				   <p>Add path from cloud storage</p>
			   </div>
			   <div class="col-lg-12 form-group">
				   <input type="text" [ngModel]  name="s6_path" class="form-control pathLink" placeholder="Add s3://path" 
				 #s6_path="ngModel" required [ngClass]="{'is-invalid': f_s6.submitted && s6_path.invalid }">
				<div *ngIf="f_s6.submitted && s6_path.invalid" class="invalid-feedback">
				   <div *ngIf="s6_path.errors.required">s3 path is required</div>
				 </div>
			   </div>
			   <div class="col-lg-12 text-center mt-3 form-group">
				   <button type="submit" class="btn btn-primary px-3 pathButton">Add</button>
			   </div>
			 </form>
			 </div>
		 </div>
		</div>
	  </div>
	</div>
  </div>
  
  <!-- End of Add Dataset modal -->

  <!-- Add Metadata modal -->
 
 <div class="modal fade uploadmodal4" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered" role="document">
	  <div class="modal-content">
		  <div class="close_icon">
			  <a data-target="uploadmodal4" data-dismiss="modal"><img src="./assets/image/icons/close.png"></a>
		  </div>
		<div class="modal-body">
			<div class="row mt-1">
				<div class="col-lg-11 text-center">
					<p class="pl-5">
						<span class="underline">Add Path</span>
					</p>
				</div>
			</div>
			<div class="row justify-content-center mr-1 mt-4 mb-2">
				<div class="col-lg-5">
					<a (click)="path4($event)"><img src="./assets/image/upload_drive.png" width="190"></a>
			 </div>
			 <div class="col-lg-1 pt-5">
				 <p class="uploadOption">OR</p>
			 </div>
			 <div class="col-lg-5">
					<img src="./assets/image/upload_folder.png" width="190" id="localpath5">
				<input type="file" name="upload" class="form control" id="inputlocalpath5" hidden>
			 </div>
		 </div>
		</div>
	  </div>
	</div>
  </div>
  
  <div class="modal fade uploadpath4" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered" role="document">
	  <div class="modal-content">
		  <div class="close_icon">
			  <a data-target="uploadpath4" data-dismiss="modal"><img src="./assets/image/icons/close.png"></a>
		  </div>
		<div class="modal-body">
			<div class="row mt-1 mb-3">
				<div class="col-lg-11 text-center">
					<p class="pl-5">
						<span class="underline">Add Path</span>
					</p>
				</div>
			</div>
			<div class="row mt-2">
				<div class="card-body uploadCard mx-3">
			  <form (ngSubmit)="f_s7.form.valid && onSubmit_dts7path(f_s7)" #f_s7="ngForm">
			   <div class="col-lg-12 text-center pathText">
				   <p>Add path from cloud storage</p>
			   </div>
			   <div class="col-lg-12 form-group">
				   <input type="text" [ngModel]  name="s7_path" class="form-control pathLink" placeholder="Add s3://path" 
				 #s7_path="ngModel" required [ngClass]="{'is-invalid': f_s7.submitted && s7_path.invalid }">
				<div *ngIf="f_s7.submitted && s7_path.invalid" class="invalid-feedback">
				   <div *ngIf="s7_path.errors.required">s3 path is required</div>
				 </div>
			   </div>
			   <div class="col-lg-12 text-center mt-3 form-group">
				   <button type="submit" class="btn btn-primary px-3 pathButton">Add</button>
			   </div>
			 </form>
			 </div>
		 </div>
		</div>
	  </div>
	</div>
  </div>
  
  <!-- end of metadata modal -->


  <!-- Add data flow modal -->
 
 <div class="modal fade uploadmodal5" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered" role="document">
	  <div class="modal-content">
		  <div class="close_icon">
			  <a data-target="uploadmodal4" data-dismiss="modal"><img src="./assets/image/icons/close.png"></a>
		  </div>
		<div class="modal-body">
			<div class="row mt-1">
				<div class="col-lg-11 text-center">
					<p class="pl-5">
						<span class="underline">Add Path</span>
					</p>
				</div>
			</div>
			<div class="row justify-content-center mr-1 mt-4 mb-2">
				<div class="col-lg-5">
					<a (click)="path5($event)"><img src="./assets/image/upload_drive.png" width="190"></a>
			 </div>
			 <div class="col-lg-1 pt-5">
				 <p class="uploadOption">OR</p>
			 </div>
			 <div class="col-lg-5">
					<img src="./assets/image/upload_folder.png" width="190" id="localpat6">
				<input type="file" name="upload" class="form control" id="inputlocalpath7" hidden>
			 </div>
		 </div>
		</div>
	  </div>
	</div>
  </div>
  
  <div class="modal fade uploadpath5" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered" role="document">
	  <div class="modal-content">
		  <div class="close_icon">
			  <a data-target="uploadpath4" data-dismiss="modal"><img src="./assets/image/icons/close.png"></a>
		  </div>
		<div class="modal-body">
			<div class="row mt-1 mb-3">
				<div class="col-lg-11 text-center">
					<p class="pl-5">
						<span class="underline">Add Path</span>
					</p>
				</div>
			</div>
			<div class="row mt-2">
				<div class="card-body uploadCard mx-3">
			  <form (ngSubmit)="f_s8.form.valid && onSubmit_dts7path(f_s8)" #f_s8="ngForm">
			   <div class="col-lg-12 text-center pathText">
				   <p>Add path from cloud storage</p>
			   </div>
			   <div class="col-lg-12 form-group">
				   <input type="text" [ngModel]  name="s7_path" class="form-control pathLink" placeholder="Add s3://path" 
				 #s7_path="ngModel" required [ngClass]="{'is-invalid': f_s8.submitted && s7_path.invalid }">
				<div *ngIf="f_s8.submitted && s7_path.invalid" class="invalid-feedback">
				   <div *ngIf="s7_path.errors.required">s3 path is required</div>
				 </div>
			   </div>
			   <div class="col-lg-12 text-center mt-3 form-group">
				   <button type="submit" class="btn btn-primary px-3 pathButton">Add</button>
			   </div>
			 </form>
			 </div>
		 </div>
		</div>
	  </div>
	</div>
  </div>
  
  <!-- end of data flow modal -->

  

